import { Component } from '@angular/core';
import { dayjs } from '@karve.it/core';
import { Store, createSelector } from '@ngrx/store';


import { PlusAuthenticationService } from '../../core/public-api';
import { FreyaCommonModule } from '../../freya-common/freya-common.module';
import { JobHeaderActions } from '../../job/job-header/job-header.actions';
import { JobStatusDropdownComponent } from '../../job/job-header/job-status-dropdown/job-status-dropdown.component';
import { JobTagsComponent } from '../../job/job-header/job-tags/job-tags.component';
import { selectCustomerName, selectJob } from '../../job/job-tool.reducer';

@Component({
    selector: 'app-job-header-details',
    standalone: true,
    imports: [
        FreyaCommonModule,
        JobStatusDropdownComponent,
        JobTagsComponent,
    ],
    templateUrl: './job-header-details.component.html',
    styleUrl: './job-header-details.component.scss',
})
export class JobHeaderDetailsComponent {

    viewModel$ = this.store.select(createSelector({
        header: createSelector(selectJob, selectCustomerName, (job, customerName) => job ? customerName : 'New Job'),
        job: selectJob,
        date: createSelector(selectJob, (job) => {
          if (!job) return '';
          if (job.timeline) {
            return dayjs(job.timeline, 'YYYY-MM-DD').format('MMM DD YYYY');
          }
          if (job.createdAt) {
            return dayjs(job.createdAt * 1000).format('MMM DD YYYY');
          }
          return '';
        }),
        dateTooltip: createSelector(selectJob, (job) => job?.timeline ? 'Timeline' : 'Created'),
    }));

    actions = JobHeaderActions;

    constructor(
        public store: Store,
        public authSvc: PlusAuthenticationService,
    ) {}
}
